import Cookies from "js-cookie";

export const EPS_LANGUAGE_COOKIE: string = "epslanguage";

const setLanguageCookie = (value: string) => {
  Cookies.set(EPS_LANGUAGE_COOKIE, value);
};

export default setLanguageCookie;
